import React from 'react';
import { Sparkles, Phone, MapPin, CheckCircle2 } from 'lucide-react';
export function Page31HeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-2779">
      <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-2780">
        <Sparkles className="w-4 h-4" data-id="element-2781" />
        Start Here
      </div>

      <div className="mb-8 inline-flex flex-nowrap items-center gap-3 text-sm md:text-base font-bold text-ink bg-white/90 backdrop-blur-sm py-2 px-4 rounded-full shadow-sm border border-subtle-gray w-fit max-w-full whitespace-nowrap" data-id="element-2782">
        <span className="text-gold tracking-wider shrink-0" data-id="element-2783">★★★★★</span>
        <span className="text-subtle-gray shrink-0" data-id="element-2784">|</span>
        <span className="shrink-0" data-id="element-2785">5.0 Rating From 201 Reviews</span>
      </div>

      <h1 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-[1.1]" data-id="element-2786">
        Start a Trial at Storm Taekwondo
      </h1>

      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-2787">
        Begin with a simple trial class and let Storm help you choose the right
        class or program for your child, yourself, or your family.
      </p>

      <ul className="flex flex-wrap gap-x-5 gap-y-2 mb-8" data-id="element-2788">
        {['Ages 3+', 'Beginner-Friendly', 'No Experience Needed', 'Kids · Adults · Families'].map(label => <li key={label} className="flex items-center gap-2 text-off-white text-sm" data-id="element-2789">
            <CheckCircle2 className="w-4 h-4 text-storm-red shrink-0" data-id="element-2790" />
            <span data-id="element-2791">{label}</span>
          </li>)}
      </ul>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-2792">
        <a href="#signup-form" className="btn-primary text-center" data-id="element-2793">
          Check Availability
        </a>
        <a href="tel:517-220-0621" className="btn-secondary flex items-center justify-center gap-2" data-id="element-2794">
          <Phone className="w-5 h-5" data-id="element-2795" />
          Call 517-220-0621
        </a>
      </div>

      <div className="flex items-start gap-3 text-off-white/80 text-sm" data-id="element-2796">
        <MapPin className="w-5 h-5 text-storm-red shrink-0 mt-0.5" data-id="element-2797" />
        <p data-id="element-2798">
          24786 Crestview, Farmington Hills, MI 48335 — minutes from Novi,
          Commerce, Walled Lake, Wixom, Livonia, Northville and Waterford.
        </p>
      </div>
    </div>;
}